import React from 'react'
import {
	Form
} from "antd"
import { InputMask } from 'primereact/inputmask';

export const MaskedInput = (props) => {
	const { 
        className,
        initialValue, 
        label, 
        form,
        fieldName, 
        correctLength, 
        regexForField, 
        regexForAllowedSymbols,
        regexForDeletingSymbols,
        enterMessage,
        validateMessage,
        mask, 
        placeholder, 
        required = false, 
        ...otherProps } = props
	const handlePress = (e, allowedChars) => {
		if (!allowedChars.test(e.key)) {
			e.preventDefault();
		}
	}

	const validateField = (_, value) => {
		value = value.replace(regexForDeletingSymbols, '');
		if(!value || value.length === 0){
			return Promise.resolve();
		}
		if(value.length === correctLength){
			if (regexForField.test(value)){
				form.setFieldsValue({[fieldName]: value})
				return Promise.resolve();
			} else
				return Promise.reject(validateMessage)
		}
		if(value.length > 0 && value.length < correctLength){
			return Promise.reject(enterMessage)
		}
	}

    return (
        <Form.Item
            initialValue={initialValue}
            label={label}
            name={fieldName}
            rules={[
                {
                    validator: validateField,
                    required: required
                }
            ]}
        >
            <InputMask
                mask={mask}
                placeholder={placeholder}
                autoClear={false}
                className={className}
            >
                {(inputProps) => (
                    <CustomInput
                        {...inputProps}
                        onKeyPress={(e) => handlePress(e, regexForAllowedSymbols)}
                    />
                )}
            </InputMask>
        </Form.Item>                   
    )
}
